import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Timber crane vehicle
 * Features a crane arm for handling logs
 */
export const timberCraneShape: VehicleShapeDefinition = {
  vehicle: 'timber_crane',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    // Front wheels
    front_wheel_left: [
      [15, 10],
      [35, 10],
      [35, 35],
      [15, 35],
    ],

    front_wheel_right: [
      [65, 10],
      [85, 10],
      [85, 35],
      [65, 35],
    ],

    // Rear wheels
    rear_wheel_left: [
      [15, 70],
      [35, 70],
      [35, 95],
      [15, 95],
    ],

    rear_wheel_right: [
      [65, 70],
      [85, 70],
      [85, 95],
      [65, 95],
    ],

    // Main body
    body: [
      [25, 30],
      [75, 30],
      [75, 75],
      [25, 75],
    ],

    // Crane base
    crane_base: [
      [35, 45],
      [65, 45],
      [65, 60],
      [35, 60],
    ],

    // Crane arm extending forward
    crane_arm: [
      [40, 0],
      [60, 0],
      [60, 45],
      [40, 45],
    ],

    // Crane grapple at the end
    crane_grapple: [
      [10, 6],
      [50, -14],
      [90, 6],
      [50, 0],
    ],
  },
  colorConfig: {
    body: { type: 'dynamic' }, // Uses vehicle color
    front_wheel_left: { type: 'fixed', color: '#000000' },
    front_wheel_right: { type: 'fixed', color: '#000000' },
    rear_wheel_left: { type: 'fixed', color: '#000000' },
    rear_wheel_right: { type: 'fixed', color: '#000000' },
    cabin: { type: 'fixed', color: '#000000' },
    crane_base: { type: 'fixed', color: '#000000' },
    crane_arm: { type: 'fixed', color: '#000000' },
    crane_grapple: { type: 'fixed', color: '#000000' },
  },
};
